import request from '@/utils/request'

let CityApi = {
  cityIndex(data, errorback) {
    return request._get('/shop/city.city/index', data, errorback);
  },
  cityAdd(data, errorback) {
    return request._post('/shop/city.city/add', data, errorback);
  },
  setCityEdit(data, errorback) {
    return request._post('/shop/city.city/edit', data, errorback);
  },
  getCityEdit(data, errorback) {
    return request._get('/shop/city.city/edit', data, errorback);
  },
  cityDelete(data, errorback) {
    return request._post('/shop/city.city/delete', data, errorback);
  },



}
export default CityApi;



// WEBPACK FOOTER //
// ./src/api/city.js